// Legacy window globals — MUST be the FIRST import of main.ts: module-eval-time
// code in the widget tree (prototype-hoisted field initializers like
// `new email_FileUploader()`) reads window.dijit/window.dojo during import, i.e.
// BEFORE main.ts's body runs. Real dojo bootstrapped these globals before any
// module executed; this module reproduces that ordering under ESM.

import registry from 'dijit/registry';
import topic from 'dojo/topic';

// Signals "packed runtime" to app code (GlobalWidgetsLoader etc.). Under Vite
// there is only the bundle runtime — dev and prod alike.
(window as any).isBundleRuntime = true;

(window as any).dijit = { registry };
(window as any).dojo = {
  publish: (t: string, args?: any) => {
    if (Array.isArray(args)) { topic.publish(t, ...args); }
    else if (args === undefined) { topic.publish(t); }
    else { topic.publish(t, args); }
  },
  subscribe: (t: string, cb: any) => topic.subscribe(t, cb),
};

// types.d.ts declares this as an AMBIENT enum (was `const enum`, inlined by the
// old tsc). esbuild cannot inline across files — provide the runtime value.
(window as any).more = Object.assign((window as any).more || {}, {
  PitHelperStructureFormatType: { json: 'json', pit: 'pit' },
});

export {};
